import Modal from "react-bootstrap/Modal"
import Spinner from "react-bootstrap/Spinner"
import Button from "../common/Button.jsx"

/**
 * Loading modal shown while BoxLabels generates a PDF.
 */
export default function BoxLabelsProgressModal({
    show,
    progress = 0,
    onCancel,
    showCancel = true,
}) {
    return (
        <Modal show={show} centered backdrop="static" keyboard={false}>
            <Modal.Header closeButton={false}>
                <Modal.Title>Generating labels to print...</Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex justify-content-center align-items-center py-4">
                <Spinner animation="border" role="status" style={{ height: "50px", width: "50px" }}>
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </Modal.Body>
            {showCancel ? (
                <Modal.Footer>
                    <Button
                        variant="outline-secondary"
                        disabled={progress === 100}
                        onClick={onCancel}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            ) : null}
        </Modal>
    )
}
